import { defineMessages } from 'react-intl-next';

export const i18n: {
	headingTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingCreator: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingModified: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingSocial: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	findMoreResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	anonymous: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorLabelsRequired: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	comments: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	likes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	headingTitle: {
		id: 'content-report-table-macro.heading.title',
		defaultMessage: 'Title',
		description: 'Table column heading for the page/blog title',
	},
	headingCreator: {
		id: 'content-report-table-macro.heading.creator',
		defaultMessage: 'Creator',
		description: 'Table column heading for the creator of the content',
	},
	headingModified: {
		id: 'content-report-table-macro.heading.modified',
		defaultMessage: 'Modified',
		description: 'Table column heading for the last modified date',
	},
	headingSocial: {
		id: 'content-report-table-macro.heading.social',
		defaultMessage: 'Activity',
		description: 'Table column heading for social activity (comments and likes)',
	},
	noResults: {
		id: 'content-report-table-macro.no.results',
		defaultMessage: 'No content found.',
		description: 'Message shown when no content matches the configured labels',
	},
	findMoreResults: {
		id: 'content-report-table-macro.find.more.results',
		defaultMessage: 'Find more results',
		description: 'Link label to view more results in advanced search',
	},
	anonymous: {
		id: 'content-report-table-macro.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Display name shown when content creator is anonymous',
	},
	error: {
		id: 'content-report-table-macro.error',
		defaultMessage: 'An error occurred while loading the content report table.',
		description: 'Generic error message for the content report table macro',
	},
	errorLabelsRequired: {
		id: 'content-report-table-macro.error.labels.required',
		defaultMessage: "'labels' parameter is required.",
		description: 'Error message when the labels parameter is missing',
	},
	comments: {
		id: 'content-report-table-macro.comments',
		defaultMessage: '{count} {count, plural, one {comment} other {comments}}',
		description: 'Accessible label for comment count',
	},
	likes: {
		id: 'content-report-table-macro.likes',
		defaultMessage: '{count} {count, plural, one {like} other {likes}}',
		description: 'Accessible label for like count',
	},
	createButton: {
		id: 'content-report-table-macro.create.button',
		defaultMessage: 'Create',
		description: 'Fallback label for the create button in blueprint blank experience',
	},
});
